import { rankWith, schemaTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { useTranslation } from "react-i18next";
import SFTextField from "../../textField";

const NumberRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
  required,
  enabled,
  errors,
}) => {
  const { t } = useTranslation();
  const { i18nKey, label, options } = uischema;

  const onChange = (e) => {
    const number = Number(e.target.value);

    if (!number) {
      return handleChange(path, undefined);
    }
    //if pattern is found and doesnt match then dont update input value
    if (schema.pattern && !new RegExp(schema.pattern).test(number)) {
      return;
    }
    handleChange(path, number);
  };

  return (
    <SFTextField
      label={i18nKey ? t(i18nKey) : label}
      value={data ? data : ""}
      variant="filled"
      type="number"
      disabled={options?.readonly || !enabled}
      readOnly={options?.readonly}
      required={required}
      onChange={onChange}
      errors={errors}
    />
  );
};

export const NumberTester = rankWith(151, schemaTypeIs("number"));

export default withJsonFormsControlProps(NumberRenderer);
